/**
 * Messages a browser produces when a lazy route's chunk no longer exists on
 * the server because a new version was deployed while the tab was open. The
 * MIME type variants come from hosts that serve index.html for a missing .js.
 */
export const STALE_CHUNK_ERROR_PATTERNS: RegExp[] = [
  /Failed to fetch dynamically imported module/i, // Chrome, Edge
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /is not a valid JavaScript MIME type/i, // Safari
  /responded with a MIME type of/i, // Chrome, Edge
  /disallowed MIME type/i, // Firefox
];

export const isStaleChunkError = (error: unknown): boolean => {
  if (!error) {
    return false;
  }
  const message =
    typeof error === 'string'
      ? error
      : ((error as { message?: string }).message ?? String(error));
  return STALE_CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};
